<template>
    <v-container fluid>
        <v-row dense>

            <!-- edit integration form -->
            <v-col>
                <v-alert
                    border="top"
                    color="green lighten-2"
                    dark
                    dismissible
                    close-text="Close"
                    v-model="successAlert.active"
                >
                  {{ successAlert.message }}
                </v-alert>

                <v-card
                    color="light"
                    padding
                    elevation="6">

                    <v-card-title class="headline">
                        Edit Integration
                        <v-spacer></v-spacer>
                        <v-switch @change="checkBilling" v-model="isActivate" color="primary" :disabled="isDeleted"></v-switch><span class="subtitle-2">Activate</span>
                    </v-card-title>


                    <v-row>
                        <v-col md="8">
                            <div class="pl-4 mb-5" v-if="isAdmin">

                                <v-btn class="mx-1" @click="onSyncNow" x-small color="error" :disabled="isSyncNow">
                                    <span v-if="isSyncNow">
                                        <v-progress-circular
                                                indeterminate
                                                size="12"
                                                width="2"
                                                color="error darken-3">
                                        </v-progress-circular>
                                        Run Now
                                    </span>
                                    <span v-else>
                                        Run Now
                                    </span>
                                </v-btn>

                                <v-btn class="mx-1" @click="showGetRecordModal = true" x-small color="error">
                                    <span>
                                        Get Record
                                    </span>
                                </v-btn>

                                <v-btn class="mx-1" @click="showSyncBackModal = true" x-small color="error">
                                    <span>
                                        Sync Back
                                    </span>
                                </v-btn>

                                <v-btn class="mx-1" @click="showCheckUpdatesBackModal = true" x-small color="error">
                                    <span>
                                        Check Updates Back
                                    </span>
                                </v-btn>

                                <v-btn class="mx-1" v-if="id > 0" :href="`/logs?filter=${id}`" x-small color="secondary">
                                    <span>
                                        View Logs
                                    </span>
                                </v-btn>

                                <v-btn class="mx-1" v-if="this.liverate" :href="`/live-rates/logs?filter=${id}`" x-small color="secondary">
                                    <span>
                                        View Liverate
                                    </span>
                                </v-btn>

                                <v-btn class="mx-1" v-if="githubCFSPath" :href="githubCFSPath" target="_blank" x-small color="secondary">
                                    <span>
                                        Custom functions
                                    </span>
                                </v-btn>
                                <v-btn class="mx-1" v-if="id > 0" :href="`/docs/integrations/integration_${id}`" target="_blank" x-small color="secondary">
                                    <span>
                                        Integration Docs
                                    </span>
                                </v-btn>

                                <v-btn class="mx-1" v-if="platform != '' && id > 0" :href="`/docs/platforms/supported/${platform}`" target="_blank" x-small color="secondary">
                                    <span>
                                        {{platform}} Docs
                                    </span>
                                </v-btn>

                                <v-btn x-small color="secondary" class="mx-1">
                                    <v-menu v-model="menu" offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on" style="cursor: pointer; color: white;">
                                                Actions
                                                <v-icon>{{ menu ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                            </span>
                                        </template>

                                        <v-list>
                                            <v-list-item>
                                                <v-list-item-title><ExportModal v-if="isAdmin" :id="id" /></v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-title><ImportRecordModal v-if="isAdmin" @recordImported="onRecordImported" /></v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-title><ConfirmArchiveModal v-if="isAdmin" :integration="integration" :id="id" /></v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-btn>

                            </div>
                            <div class="pl-5" v-if="integration && integration.client_token">
                                <v-btn icon class="mr-3" @click="onCopyToken">
                                    <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col md="4">
                            <div class="pr-4 d-flex align-items-center justify-content-end">
                                <v-switch v-model="liverate" @change="onLiveRateChange" color="primary" :disabled="isDeleted" ></v-switch>
                                <span class="subtitle-2">Live rates</span>
                            </div>

                            <IntegrationsLastSync
                                v-if="integration && integration.last_syncs"
                                class="pr-4"
                                :last_syncs="integration.last_syncs"
                            />
                        </v-col>

                    </v-row>

                    <v-card-title>
                        <v-spacer></v-spacer>
                        <v-switch @change="checkBilling" v-model="isTestMode" color="primary" :disabled="isDeleted"></v-switch><span class="subtitle-2">Test Mode</span>
                    </v-card-title>

                    <get-record-modal
                        :integration="id"
                        v-if="showGetRecordModal"
                        :targetFields="getTargetFields"
                        @getRecordModalClose="showGetRecordModal = false">
                    </get-record-modal>
                    <sync-back-modal
                        :integration="id"
                        v-if="showSyncBackModal"
                        @syncBackModalClose="showSyncBackModal = false">
                    </sync-back-modal>
                    <check-updates-back-modal
                        :integration="id"
                        v-if="showCheckUpdatesBackModal"
                        @modalClose="showCheckUpdatesBackModal = false">

                    </check-updates-back-modal>

                    <div ref="firstTab"></div>

                    <integrations-form
                        ref="integrationsForm"
                        v-if="integration"
                        :integration="integration"
                        :integration_id="id"
                        :integration_type_id="integration.integration_type_id"
                        :submit="onUpdate"
                        :isSubmit="isSubmit"
                        :is_disabled="isDeleted"
                        submitText="Update">
                    </integrations-form>
                    <v-progress-linear
                        v-else
                        indeterminate
                        color="primary"
                        class="mb-5"
                    ></v-progress-linear>


                    <div class="mt-5 p-3" v-if="integration && !isDeleted">
                        <integrations-mapping :integration="integration"></integrations-mapping>
                    </div>

                </v-card>
            </v-col>
        </v-row>

        <Modal
            ref="confirmation"
            color="warning"
            okText="update" />

        <Modal
            ref="billingPrompt"
            color="warning"
            width="450"
            :persistent="false"
            cancelText="Close"
            okText="Open Billing Settings" />
    </v-container>
</template>

<script>
import IntegrationsForm from './forms/IntegrationsForm.vue';
import IntegrationsMapping from './IntegrationsMapping.vue';
import IntegrationsLastSync from "./IntegrationsLastSync";
import GetRecordModal from "./modal/GetRecordModal";
import SyncBackModal from "./modal/SyncBackModal";
import CheckUpdatesBackModal from "./modal/CheckUpdatesBackModal";
import ExportModal from "./modal/ExportModal";
import Modal from "@/js/components/Modal.vue";
import { EventBus } from '@/js/event-bus.js';
import ImportRecordModal from "~/integrations/modal/ImportRecordModal";
import ConfirmArchiveModal from "~/integrations/modal/ConfirmArchiveModal";
const localPrefix = window.IS_LOCAL ? "[LOCAL] ":"";

export default {
    components: {
        IntegrationsForm,
        IntegrationsMapping,
        IntegrationsLastSync,
        GetRecordModal,
        SyncBackModal,
        CheckUpdatesBackModal,
        ExportModal,
        Modal,
        ImportRecordModal,
        ConfirmArchiveModal
    },

    data() {
        return {
            id: null,
            integration: null,
            isSubmit: false,
            tab: 'tab-machship-keys',
            isActivate: null,
            isTestMode: null,
            isSyncNow:false,
            liverate: false,
            showGetRecordModal: false,
            showSyncBackModal: false,
            showCheckUpdatesBackModal: false,
            successAlert: {
                active: false,
                message: ''
            },
            isDeleted: false,
            platform: '',
            menu: false,

            // for tracking billing changes
            billing: {}
        }
    },

    computed: {
        isAdmin() {
            return this.$store.getters.isAdmin
        },

        getLiverate() {
            return this.integration.metas.find(meta => (meta.meta_key == 'LIVE_RATE'))
        },

        githubCFSPath() {
            if (this.id) {
                return 'https://github.com/machship/fusedship-sync/tree/master/app/Services/CustomFunctions/integration_' + this.id;
            }
        },

        getTargetFields() {
            return this.integration.target_fields ?? [];
        }
    },

    mounted() {
        this.id = parseInt(this.$route.params.id)

        let query = this.$route.query

        if (typeof query.success !== 'undefined') {
            this.successAlert.message = "Congratulation! OAuth2 successful, access token and refresh token were save for this integration"
            this.successAlert.active = true
        }

        this.$http
            .get('/api/integrations/' + this.id)
            .then(({ data }) => {

                this.integration = data.data.attributes
                this.updateBilling(this.integration)

                this.isActivate = this.integration.integration_status == 'active' ? true : false
                this.isTestMode = this.integration.is_test == 'active' ? true : false
                this.liverate = this.integration.live_rate_active
                this.isDeleted = this.integration.deleted_at ? true : false
                // so its easier to find specific integration with multiple tabs
                document.title = this.integration.label  + ` Edit - ${localPrefix}Fusedship`;


                // get the integration type of this integration
                const integType = this.integration.integration_type.display_name ?? null;
                if (integType) {
                    this.platform = integType.replace(/\s+/g, '-').toLowerCase();
                }
            })
            .catch(err => {
                let message = (typeof err.response.data.error.message !== 'undefined') ? err.response.data.error.message : err;
                EventBus.$emit('show-error', message);
                setTimeout(() => {
                    this.$router.push({name: 'integrations list' });
                }, 3000);
            })
    },

    watch: {
        isActivate: function (value, oldValue) {
            if (oldValue != null) {
                this.onSetActivation(value)
            }
        },
        isTestMode: function (value, oldValue) {
            if (oldValue != null) {
                this.onSetMode(value)
            }
        }

    },

    methods: {

        onUpdate(data) {
            if (this.isSubmit) {
                return
            }

            this.isSubmit = true
            this.$http
                .put('/api/integrations/' + this.id, data)
                .then(res => {
                    this.updateBilling(res.data.data.attributes);
                    // show info
                    EventBus.$emit('show-success', 'Successfully saved integrations.');
                    this.isSubmit = false
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                    this.isSubmit = false
                })
        },

        onSetActivation(value) {
            let status = value ? 'active' : 'inactive'
            this.$http
                .post('/api/integrations/activate', {
                    integration_id: this.id,
                    integration_status: status
                })
                .then(() => {
                    EventBus.$emit('show-success', 'Successfully sets integration status to ' + status)
                })
                .catch(err => {
                    EventBus.$emit('show-error', err)
                })
        },

        onSetMode(value) {
            let status = value ? 'active' : 'inactive'
            this.$http
                .post('/api/integrations/mode', {
                    integration_id: this.id,
                    is_test: status
                })
                .then(() => {
                    EventBus.$emit('show-success', 'Test Mode status ' + status)
                })
                .catch(err => {
                    EventBus.$emit('show-error', err)
                })
        },

        onSyncNow() {
            this.isSyncNow = true
            this.$http
                .post('/api/sync/now', {
                    integration_id: this.id
                })
                .then(({ data }) => {
                    EventBus.$emit('show-success', 'Sync Successfully Executed!!')
                    this.isSyncNow = false
                })
                .catch(err => {
                    EventBus.$emit('show-error', err)
                    this.isSyncNow = false
                })
        },

        onShowLastSync() {
            this.$refs.lastSyncModal.onShow();
        },

        onLiveRateChange(value) {

            this.checkBilling()

            let toActivate = value == 1 ? 'Activate' : 'Deactivate'

            this.$refs.confirmation.onShow(
                'Confirmation',
                'Are you you want to ' + toActivate + ' Live rates?',
                async () => {
                    try {

                        let { data } = await this.$http.post('/api/integrations/activate/liverate', {
                            id: this.id,
                            activate: value
                        })

                        if (data.activation?.message) {
                            EventBus.$emit('show-error', data.activation.message)
                            this.liverate = !value

                        } else {
                            if (toActivate == 'Deactivate') {
                                EventBus.$emit('show-success', 'Successfully deactivated liverates configurations.')
                            } else {
                                EventBus.$emit('show-success', 'Successfully activated liverates configurations.')
                            }

                            setTimeout(() => {
                                window.location.reload()
                            }, 800)
                        }
                    } catch (err) {
                        EventBus.$emit('show-error', err)
                    }
                },
                () => {
                    this.liverate = !value
                }
            )
        },

        onExport() {
            // show confirmation here

        },

        onCopyToken() {
            if (this.integration.client_token) {
                navigator.clipboard.writeText(this.integration.client_token)
                EventBus.$emit('show-success', "Copy client token to clipboard");
            }
        },

        onRecordImported(newRecord) {
            this.record = newRecord;
        },

        checkBilling() {
            const billing = this.billing;

            const isSetupChargedOn = billing.setup_charged;
            const hasSetupFee = billing.setup_fee > 0;
            const invalidSetupFee = isSetupChargedOn && !hasSetupFee;

            const isMonthlyChargedOn = billing.monthly_charged;
            const hasMonthlyFee = billing.monthly_fee > 0;
            const invalidMonthlyFee = isMonthlyChargedOn && !hasMonthlyFee;

            // if setup fee is switched on but no setup fee is set
            // or monthly fee is switched on but no monthly fee is set
            if (invalidSetupFee || invalidMonthlyFee) {
                this.$refs.billingPrompt.onShow(
                    'Ensure billing information is updated',
                    `If making an integration live, please confirm the billing dates and amounts are updated.`,
                    () => {
                        this.$refs.integrationsForm.switchToBillingTab()
                        this.$nextTick(() => {
                            this.$refs.firstTab.scrollIntoView({ behavior: "smooth" });
                        });
                    }
                )
            }
        },

        updateBilling(integration) {
            this.billing = {
                setup_charged: integration.setup_charged,
                setup_fee: integration.setup_fee,
                monthly_charged: integration.monthly_charged,
                monthly_fee: integration.monthly_fee,
            }
        }
    }
}
</script>
